module.exports = __webpack_public_path__ + "img/save-print-box-zh.7f218384.png";